import { render } from "./CreateBudget.vue?vue&type=template&id=a6bf2dde"
import script from "./CreateBudget.vue?vue&type=script&lang=js"
export * from "./CreateBudget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__